import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import IconButtonAbsoluteMenu from '__components/Tables/Big/IconButtonAbsoluteMenu';
import { colorsButton } from '__app/colors';
import Icon from '__components/Kizen/Icon';
import { GradientRightRow } from '__components/Kizen/LazyLoad/helpers';
import { layers } from '__app/spacing';
import {
  getActions,
  getLoggedActions,
  StyledIconButton,
  ZIndexActionMenuWrapper,
} from '__pages/ActivitySettings/pages/ScheduledAndLogged/Table';
import SizedCell from '__pages/ActivitySettings/pages/ScheduledAndLogged/components/SizedCell';

const ControlsCell = styled((props) => {
  const { t } = useTranslation();
  const {
    onSelectAction,
    showNotesId,
    data: activity,
    activityObject,
    tableType = 'scheduled',
    showActionMenu = true,
    showIconButton = true,
  } = props;
  const { access = {} } = activity;
  const options =
    tableType === 'logged'
      ? getLoggedActions({
          submissionAction: activityObject?.submissionAction,
          t,
        })
      : getActions(access, showNotesId === activity.id, t);

  const actionMenu = (
    <IconButtonAbsoluteMenu
      sizing="dense"
      title={tableType === 'scheduled' ? t('Edit Activity') : t('Actions')}
      position="right"
      color={colorsButton.iconGray}
      options={options}
      onChange={(option: any) => onSelectAction(option, activity)}
    >
      <Icon icon="three-dot" />
    </IconButtonAbsoluteMenu>
  );
  const iconButton = (
    //@ts-expect-error - StyledIconButton is missing a prop
    <StyledIconButton
      sizing="dense"
      color={colorsButton.iconGray}
      title={t('Complete Activity')}
      onClick={() => onSelectAction(options[0], activity)}
      zIndex={props.virtualized ? 1 : undefined}
    >
      <Icon icon="check" />
    </StyledIconButton>
  );

  return (
    <SizedCell {...props}>
      {!showActionMenu || options.length === 0 ? null : (
        <>
          {showIconButton && iconButton}
          {props.virtualized ? (
            <ZIndexActionMenuWrapper>{actionMenu}</ZIndexActionMenuWrapper>
          ) : (
            actionMenu
          )}
        </>
      )}
      {/* When virtualizing rows, we need to handle the fade on a per-row basis */}
      {props.virtualized ? <GradientRightRow fadeIn /> : null}
    </SizedCell>
  );
})`
  position: sticky;
  right: 0;
  z-index: ${layers.content(0, 1)};
  > div {
    margin-left: -1px;
    display: flex;
    justify-content: flex-end;
  }
`;
export default ControlsCell;
